<template>
  <div class="textEditor">
    <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
      <div class="menubar">
        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.bold() }"
          @click="commands.bold"
        >
          <b-icon icon="format-bold" />
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic"
        >
          <b-icon icon="format-italic" />
        </button>

        <!-- <button
          class="menubar__button"
          :class="{ 'is-active': isActive.strike() }"
          @click="commands.strike"
        >
          <b-icon icon="format-strikethrough" />
        </button> -->

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.underline() }"
          @click="commands.underline"
        >
          <b-icon icon="format-underline" />
        </button>

        <!-- <button
          class="menubar__button"
          :class="{ 'is-active': isActive.code() }"
          @click="commands.code"
        >
          <b-icon icon="code-tags" />
        </button> -->

        <!-- <button
          class="menubar__button"
          :class="{ 'is-active': isActive.paragraph() }"
          @click="commands.paragraph"
        >
          <b-icon icon="format-paragraph" />
        </button> -->

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.heading({ level: 1 }) }"
          @click="toggleCommand(isActive.heading({ level: 1 }), 'h1')"
        >
          <b-icon icon="format-header-1" />
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.heading({ level: 2 }) }"
          @click="toggleCommand(isActive.heading({ level: 2 }), 'h2')"
        >
          <b-icon icon="format-header-2" />
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.heading({ level: 3 }) }"
          @click="toggleCommand(isActive.heading({ level: 3 }), 'h3')"
        >
          <b-icon icon="format-header-3" />
        </button>

        <!-- <button
          class="menubar__button"
          :class="{ 'is-active': isActive.bullet_list() }"
          @click="commands.bullet_list"
        >
          <b-icon icon="format-list-bulleted" />
        </button> -->

        <!-- <button
          class="menubar__button"
          :class="{ 'is-active': isActive.ordered_list() }"
          @click="commands.ordered_list"
        >
          <b-icon icon="format-quote-close" />
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.blockquote() }"
          @click="commands.blockquote"
        >
          <b-icon icon="format-list-numbered" />
        </button> -->

        <!-- <button
          class="menubar__button"
          :class="{ 'is-active': isActive.code_block() }"
          @click="commands.code_block"
        >
          <b-icon icon="code-tags" />
        </button> -->

        <!-- <button class="menubar__button" @click="commands.horizontal_rule">
          <b-icon icon="minus" />
        </button> -->

        <button class="menubar__button" @click="commands.undo">
          <b-icon icon="undo" />
        </button>

        <button class="menubar__button" @click="commands.redo">
          <b-icon icon="redo" />
        </button>
      </div>
    </editor-menu-bar>

    <editor-content class="textEditor__content" :editor="editor" />
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import {
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  History
} from "tiptap-extensions";

export default {
  name: "textEditor",
  components: {
    EditorContent,
    EditorMenuBar
  },
  props: {
    text: {
      type: String
    }
  },
  methods: {
    toggleCommand(isCommandActive, commandType) {
      if (isCommandActive) {
        this.editor.commands.paragraph();
        this.editor.isActive.paragraph();
      } else {
        if (commandType === "h1") {
          this.editor.commands.heading({ level: 1 });
          this.editor.isActive.heading({ level: 1 });
        } else if (commandType === "h2") {
          this.editor.commands.heading({ level: 2 });
          this.editor.isActive.heading({ level: 2 });
        } else if (commandType === "h3") {
          this.editor.commands.heading({ level: 3 });
          this.editor.isActive.heading({ level: 3 });
        }
      }
    }
  },
  data() {
    return {
      editor: new Editor({
        extensions: [
          new Heading({ levels: [1, 2, 3] }),
          new Italic(),
          new Bold(),
          new Strike(),
          new Underline(),
          new History()
        ],
        content: this.text || "",
        onUpdate: value => {
          const html = value.getHTML();
          this.$emit("update", html);
        }
      })
    };
  },
  beforeDestroy() {
    this.editor.destroy();
  }
};
</script>
